import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Panel, SectionTitle, EmptyState } from "@/components/portal/Bits";
import { Flame, Zap, TrendingUp, Trophy } from "lucide-react";

const ICONS = { engagement_spike: Zap, follower_surge: TrendingUp, on_field: Trophy };

export default function Alerts() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/alerts");
      setData(data);
    })();
  }, []);

  if (!data) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div>
      <SectionTitle sub="Real-time signals across the roster — only from verified data.">Heat Alerts</SectionTitle>

      {data.alerts.length === 0 ? (
        <EmptyState
          testId="alerts-empty"
          icon={Flame}
          title="No alerts yet"
          hint="Alerts fire from real signals: engagement spikes, follower surges, and on-field movement. PFF movement activates only with a licensed feed. Add weekly snapshots to build history."
        />
      ) : (
        <div className="space-y-3" data-testid="alerts-list">
          {data.alerts.map((a, i) => {
            const Icon = ICONS[a.type] || Flame;
            return (
              <Link key={i} to={`/athlete/${a.athlete_id}`} data-testid={`alert-${i}`}>
                <Panel className="p-5 flex items-start gap-4 hover:border-white/30 transition-colors">
                  <div className="rounded-md bg-[#E1FF00]/10 border border-[#E1FF00]/30 p-2">
                    <Icon className="h-5 w-5 text-[#E1FF00]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-white">{a.athlete_name}</span>
                      <span className="text-[10px] uppercase tracking-wider text-muted-foreground">{a.week}</span>
                    </div>
                    <div className="text-sm text-white mt-0.5">{a.title}</div>
                    <div className="text-sm text-muted-foreground">{a.detail}</div>
                  </div>
                  <span className="text-[10px] uppercase tracking-wider text-[#E1FF00]">{a.severity}</span>
                </Panel>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
